import { Component, Inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-produto-kit',
    templateUrl: './produto-kit.component.html',
    styleUrls: ['./produto-kit.component.scss'],
    standalone: false
})
export class ProdutoKitComponent implements OnInit {
  data;
  condition="0=0"
  constructor(@Inject(NZ_MODAL_DATA) public ob, public dialogRef:NzModalRef<any>) { }

  ngOnInit(): void {
    this.data = this.ob['cardRow'];

    this.condition = `this.codecontract=${this.data.linha['CODECONTRACT']} and this.codeproduct=${this.data.linha['CODEPRODUCT']}`
  }



  fechar(){
      this.dialogRef.close();

  }

}
